import { forwardRef as e, useEffect as t, useImperativeHandle as n, useRef as r } from "react";
import { jsx as i } from "react/jsx-runtime";
// src/design/breadcrumbs/@/components/link/index.tsx
var a = e(function({ as: e, autoFocus: a, isLast: o, ...s }, c) {
	let l = r(null), u = r(null);
	return n(c, () => o ? u.current : l.current, [o]), t(() => {
		a && l.current && l.current.focus();
	}, [a]), o ? /* @__PURE__ */ i("span", {
		"aria-current": "page",
		ref: u,
		...s
	}) : /* @__PURE__ */ i(e || "a", {
		ref: l,
		...s
	});
});
a.displayName = "Link";
export { a as Link };

//# sourceMappingURL=index.js.map